<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="allBack" />
    <div class="back">
      <img src="/img/activity/liveDrawBack.jpg">
    </div>
    <div class="code">-{{ code }}-</div>
    <div class="downImg">
      <img src="/img/activity/liveDrawDown.png">
    </div>
    <van-dialog
      v-model="showfollowWx"
      title="请关注SSI国际水肺潜水学校公众号"
      show-cancel-button
      @confirm="onFllowConfirm"
      @cancel="onFllowCancel"
    >
      <img class="qrCode" src="/img/qrwx.jpg ">
    </van-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey } from '@/utils/base'
import { Button, Dialog, Toast } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      title: '现场抽奖',
      backurl: '/home/index',
      showfollowWx: false,
      data: {},
      code: undefined,
      key: undefined
    }
  },

  created() {
    this.key = this.$route.params.id
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.init()
  },
  methods: {
    init() {
      Toast.loading({
        mask: false,
        message: '加载中...'
      })
      request({
        url: '/Activity/getUserSimpleInfo',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          Toast.clear(true)
          return
        }
        this.data = Response.data
        if (!this.data.followWx) {
          Toast.clear(true)
          this.$store.dispatch('user/resetToken', '')
          this.showfollowWx = true
          return
        }
        this.getLiveDrawCode()
      })
    },
    getLiveDrawCode() {
      request({
        url: '/Activity/regAndGetLiveDrawCode',
        method: 'post',
        params: { key: this.key }
      }).then(Response => {
        Toast.clear(true)
        if (!Response.success) {
          return
        }
        this.code = Response.data
      })
    },
    onFllowConfirm() {
      this.init()
    },
    onFllowCancel() {
      this.$router.replace('/home/index')
    }
  }
}
</script>
<style scoped>
.qrCode{
 width: 100%;
   box-sizing: border-box;
 padding: 2em;
}
.code{
    position: absolute;
    text-align: center;
    font-size: 5em;
    width: 100%;
    margin-top: 40vh;
    z-index: 2;
    color: #fff;
    text-shadow:3px 2px 3px #000;
}
.back{
  position: absolute;
  width: 100%;
  z-index: 1;
}
.back img{
  width: 100%;
}
.downImg{
  position: absolute;
  width: 100%;
  z-index: 1;
  bottom:0px;
  text-align: center;
}
.downImg img{
  width: 50%;
}
.allBack{
  position: absolute;
  width: 100%;
  min-height: 100vh;
  background-color: #041624;
  z-index: 0;
}
</style>
